module.exports = __webpack_public_path__ + "static/media/present-ribbon@2x.f1598a09.png";